import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpandVertical = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 7 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.5 11.6667L0 8.16667L0.83125 7.33542L3.5 10.0042L6.16875 7.33542L7 8.16667L3.5 11.6667ZM0.845833 4.31667L0 3.5L3.5 0L7 3.5L6.15417 4.31667L3.5 1.6625L0.845833 4.31667Z",
		fill: "currentColor"
	})
});
export default SvgExpandVertical;
